import React, { FC } from 'react'
import InlineSvg from 'react-inlinesvg'
import sprite from 'assets/sprite.svg'
import 'assets/sprite.css'

interface Props {
  onLoad?: () => any
}

export const SvgSprite: FC<Props> = ({ onLoad = () => {} }) => (
  <InlineSvg src={sprite} uniquifyIDs={false} onLoad={onLoad} />
)
